var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMatchLine)?_c('tr',{staticClass:"line_expansion match"},[_c('diff-expansion-cell',{attrs:{"file-hash":_vm.fileHash,"context-lines-path":_vm.contextLinesPath,"line":_vm.line,"is-top":_vm.isTop,"is-bottom":_vm.isBottom}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }